import { useEffect, useState } from "react";
import queryString from "query-string";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import LoaderIcon from "../loaderIcon";
import { setSending } from "../../store/interaction";
import { RootState } from "../../store/store";
import { PostPlanData } from "../../store/ioThunk";

export interface PostOptions {

    title: string,
    model: number,
    content: string | null,
    completed: boolean

}
const PostData = () => {
    const dispatch = useAppDispatch();
    const modelData = useAppSelector((store: RootState) => store.model.present.model)
    const [errorMessage,] = useState<string | null>(null);

    useEffect(() => {
        const parsed = queryString.parse(window.location.search);
        const URIFrom = parsed.linkFrom;
        const fileExportURI = Array.isArray(URIFrom) ? null : URIFrom

        const fetchData = async () => {
            const postData: PostOptions = {
                title: "2dEditor",
                model: 1,
                content: null,
                completed: false
            }
            const fetchOption = {
                method: "POST",
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            }
            dispatch(PostPlanData(fileExportURI ?? "", fetchOption, postData))

        };

        if (fileExportURI) {
            fetchData();
        } else {
            dispatch(setSending(false))
        }
    }, [dispatch, modelData]);

    return (
        <LoaderIcon>
            <div>{errorMessage}</div>
            {errorMessage && <button onClick={() => dispatch(setSending(false))}>OK</button>}
        </LoaderIcon>)
}

export default PostData;



